import { render, staticRenderFns } from "./Show-transferencia.vue?vue&type=template&id=0ba22826&scoped=true&"
import script from "./Show-transferencia.vue?vue&type=script&lang=js&"
export * from "./Show-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./Show-transferencia.vue?vue&type=style&index=0&id=0ba22826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba22826",
  null
  
)

export default component.exports